<template>
  <v-container>
    <v-data-table
      :loading="loading_data_table"
      :disabled="loading_data_table"
      :headers="headers"
      :items="meteringMops"
      sort-by="corporate_name"
      class="elevation-1"
      :pageCount="numberOfPagesPaginate"
      :page="currentPagePaginate"
      :server-items-length="totalStagesPaginate"
      :options.sync="options"
      :footer-props="{
        itemsPerPageText: 'Itens por pagina',
        itemsPerPageOptions: [5, 10, 15],
        showFirstLastPage: true,
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Medições MOP</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>

          <v-spacer></v-spacer>
          <v-text-field
            rounded
            dense
            outlined
            v-model="search"
            append-icon="mdi-magnify"
            label="Localizar"
            @click:append="searchItems()"
            @change="searchItems()"
            single-line
            hide-details
            class="mr-8"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="loadingBtnNewMetering"
            :disabled="loadingBtnNewMetering"
            rounded
            min-width="150"
            @click="addMeteringMop()"
          >
            <v-icon>mdi-plus</v-icon>
            Medição mop
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.period="{ item }">
        {{
          formatDate(item.physical_progress.date_start) +
          " - " +
          formatDate(item.physical_progress.date_end)
        }}
      </template>
      <template v-slot:item.approved="{ item }">
        <v-chip v-if="item.approved == 'yes'" color="green" text-color="white" small
          >Aprovado</v-chip
        >
        <v-chip v-else color="orange" text-color="white" small>Não Aprovado </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              color="secondary"
              @click="showTeam(item)"
            >
            <v-icon>mdi-account-group</v-icon>
            </v-btn>
          </template>
          <span>Equipe</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              color="primary"
              @click="historicContractor(item)"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
          <span>Visualizar</span>
        </v-tooltip>

      </template>

      <template v-slot:no-data> Nenhum registro encontrado </template>
    </v-data-table>

    <!-- <DialogContractorSummary v-model="dialogContractorSummary" @refreshTable="initialize()"
      :contractor="contractorSummary">
    </DialogContractorSummary> -->

    <DialogMeteringMop
      :metering_mop_id="meterigMopId"
      v-model="dialogMeteringMop1"
    ></DialogMeteringMop>

    <DialogMeteringMopTeam
      :metering_mop_id="meterigMopId"
      v-model="dialogMeteringMopTeam"
    ></DialogMeteringMopTeam>
  </v-container>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.common.js";
import DialogMeteringMop from "./_components/DialogMeteringMop.vue";
import DialogMeteringMopTeam from "./_components/MeteringMopTeam/DialogMeteringMopTeam.vue";

export default {
  components: {
    DialogMeteringMop,
    DialogMeteringMopTeam,
    // DialogContractorSummary,
  },
  data: () => ({
    meterigMopId: null,
    dialogMeteringMop1: false,
    dialogContractorSummary: false,
    contractorSummary: {},
    dialogMeteringMopTeam: false,
    loadingBtnNewMetering: false,
    loadingBtnNewPeriod: false,
    loadingRefresh: false,
    totalStagesPaginate: 0,
    numberOfPagesPaginate: 0,
    currentPagePaginate: 0,
    options: {},
    search: "",

    btnLoadingSave: false,
    loading_data_table: false,
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "MEDIÇÃO",
        align: "start",
        sortable: false,
        value: "metering_n",
      },
      {
        text: "PERÍODO",
        value: "period",
      },
      {
        text: "STATUS",
        value: "approved",
      },
      {
        text: "VALOR",
        value: "cpf",
      },
      {
        text: "",
        value: "actions",
        align: "end",
        sortable: false,
      },
    ],
    meteringMops: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      code: "",
      name: "",
    },
    defaultItem: {
      id: "",
      code: "",
      name: "",
    },
  }),

  computed: {},

  watch: {
    dialog(val) {
      val || this.close();
    },
    // dialogDelete(val) {
    //   val || this.closeDelete();
    // },
    options: {
      handler() {
        this.initialize();
      },
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions("MeteringMop", ["getHistoricMetering", "newMeteringMop"]),
    initialize() {
      this.loading_data_table = true;
      const { page, itemsPerPage } = this.options;
      this.getHistoricMetering(itemsPerPage || 10, page, this.search)
        .then((response) => {
          this.meteringMops = response.data.data;
          this.totalStagesPaginate = response.data.total;
          this.numberOfPagesPaginate = response.data.last_page;
          this.currentPagePaginate = response.data.current_page;
        })
        .finally(() => {
          this.loading_data_table = false;
        });
    },
    searchItems() {
      this.options = {};
      this.initialize();
    },
    showTeam(meteringMop) {
      this.meterigMopId = meteringMop.id;
      this.dialogMeteringMopTeam = true;
    },
    addMeteringMop() {
      this.loadingBtnNewMetering = true;
      this.newMeteringMop()
        .then((response) => {
          let meteringMop = response.data;
          //add na  lista de medição MOP
          this.meteringMops.push(meteringMop);
          //armegagem por algum motivo não está sendo atualizada com 1 item
          if (this.meteringMops.length == 1) {
            // recarregar a tabela
            this.initialize();
          }
          //abre o dialog de medição MOP
          this.meterigMopId = meteringMop.id;
          this.dialogMeteringMop1 = true;
        })
        .catch((error) => {
          if (error.response.status == 423) {
            this.$toast.error(error.response.data);
          } else {
            this.$toast.error("Erro ao criar nova medição MOP: ");
          }
        })
        .finally(() => {
          this.loadingBtnNewMetering = false;
        });
    },

    showSummary(contractor) {
      this.dialogContractorSummary = true;
      this.contractorSummary = contractor;
    },
    hitoricMetering() {
      // this.$router.push()
      //   dialogMeteringMop = true
    },

    historicContractor(meteringMop) {
      this.meterigMopId = meteringMop.id;
      this.dialogMeteringMop1 = true;
      ///this.$router.push({name:'contractor_historic',params:{contractor_id:contractor.id}})
    },
    formatDate(date) {
      let newDate = new Date(date);
      return newDate.toLocaleDateString("pt-BR", { timeZone: "UTC" });
    },
  },
};
</script>
